import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      textDecoration: 'none',
    },
    logo: {
      display: 'inline-block',
      verticalAlign: 'top',
    },
  },
  { name: 'single-tool-logo' },
);

export default useStyles;
